import React, { useState } from 'react'

export default function About() {
    let [myStyle, setmyStyle] = useState({
        color: "black",
        backgroundColor: 'white'
    })


    // let myStyle = {
    //     color: "white",
    //     backgroundColor: 'black'
    // }

    const [btnText, setbtnText] = useState("Enable Dark mode");

    const toggleStyle = () => {
//use tripple equal n react 
        if (myStyle.color === 'black') {

            setmyStyle({
                color: "white",
                backgroundColor: 'black'
            })
            setbtnText("Enable Light mode")
        } else {
            
            setmyStyle({
                color: "black",
                backgroundColor: 'white'
            })
            setbtnText("Enable Dark mode")

        }
    }
    //ham na ya style wala object bnaya 
    //remember   ham jab js mn koi style change krty hai kisi element ka to ham tab  b isi style wala    ko use krty hai
    // DOM.style.backgroundColor = "white"  // just like this style
    return (
        // ham style  da sakty ha kisi b compomnent  ko using style  or ya style aik object hots hs 
        //and one time makinf our style we can use style multiple times
        //this stye attribute is like in html

        <div className='container' style={myStyle}>
            <h1 className='my-2' >About Us</h1>
            <div className="accordion" id="accordionExample" >
                <div className="accordion-item">
                    <h2 className="accordion-header">
                        <button className="accordion-button" style={myStyle} type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                            Accordion Item #1
                        </button>
                    </h2>
                    <div id="collapseOne" className="accordion-collapse collapse show" data-bs-parent="#accordionExample">
                        <div className="accordion-body" style={myStyle}>
                            <strong>This is the first item's accordion body.</strong> It is shown by default, until the collapse plugin adds the appropriate classes that we use to style each element. These classes control the overall appearance, as well as the showing and hiding via CSS transitions. You can modify any of this with custom CSS or overriding our default variables. It's also worth noting that just about any HTML can go within the <code>.accordion-body</code>, though the transition does limit overflow.
                        </div>
                    </div>
                </div>
                <div className="accordion-item">
                    <h2 className="accordion-header">
                        <button className="accordion-button collapsed" style={myStyle} type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                            Accordion Item #2
                        </button>
                    </h2>
                    <div id="collapseTwo" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
                        <div className="accordion-body" style={myStyle}>
                            <strong>This is the second item's accordion body.</strong> It is hidden by default, until the collapse plugin adds the appropriate classes that we use to style each element. These classes control the overall appearance, as well as the showing and hiding via CSS transitions. You can modify any of this with custom CSS or overriding our default variables. It's also worth noting that just about any HTML can go within the <code>.accordion-body</code>, though the transition does limit overflow.
                        </div>
                    </div>
                </div>
                <div className="accordion-item">
                    <h2 className="accordion-header">
                        <button className="accordion-button collapsed" style={myStyle} type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                            Accordion Item #3
                        </button>
                    </h2>
                    <div id="collapseThree" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
                        <div className="accordion-body" style={myStyle}>
                            <strong>This is the third item's accordion body.</strong> It is hidden by default, until the collapse plugin adds the appropriate classes that we use to style each element. These classes control the overall appearance, as well as the showing and hiding via CSS transitions. You can modify any of this with custom CSS or overriding our default variables. It's also worth noting that just about any HTML can go within the <code>.accordion-body</code>, though the transition does limit overflow.
                        </div>
                    </div>
                </div>
            </div>
            <div className="container my-3">
                <button type="button" className="btn btn-primary" onClick={toggleStyle}>{btnText}</button>
            </div>
        </div>

    )
}
